import { createApp } from 'vue'
import App from './App.vue'

console.log('alerts-app', document.querySelector('#alerts-app'));
createApp(App).mount('#alerts-app')
